import { Injectable } from '@angular/core';
import { OrigamiHttpResponse, ServiceBase } from '@app/origami-api/services/base/service.base';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { AdditionalRequestOptions } from '@app/origami-api/services/base/request-proxy/request-proxy.class';

export interface AddQueryResponseDocumentsParams {
  siteId: number;
  queryId: number;
  senderAddress: string;
  subject: string;
  body: string;
  fileTokens?: string[];
  trueCopyCert?: boolean;
}

@Injectable()
export class RespondQueryService extends ServiceBase {
  serviceUrl = 'QueryTicketService.svc';

  addQueryResponseDocuments(
    params: FormData | AddQueryResponseDocumentsParams,
    additionalRequestOptions?: AdditionalRequestOptions,
  ): Observable<OrigamiHttpResponse> {
    return this.origamiPost(
      '/AddQueryResponseDocuments',
      params,
      {
        headers: new HttpHeaders(),
      },
      null,
      true,
      additionalRequestOptions,
    );
  }
}
